<template>

  <rate-calendar-bar
    :calendar-type="calendarType"
    :title="item.event.name"
    icon="$calendarEvent"
    :icon-color="verticalColor"
  />

</template>

<script setup lang="ts">

import RateCalendarBar from './RateCalendarBar.vue'
import type { EventEventItem } from '../types'
import VerticalRegistry from '../../../../../verticals/VerticalRegistry'

interface Props {
  item: EventEventItem
  calendarType: string
}

defineProps<Props>()

const verticalColor = VerticalRegistry.get('event')?.color

</script>
